import { Squad, User } from '../../../types';
import { hasAdminPermission } from '../../auth/adminPermissions';

type SquadAccessUser = Pick<User, 'id' | 'isAdmin' | 'adminPermissions'> | null | undefined;
type AccessibleSquad = Pick<Squad, 'teacherIds'> | null | undefined;

/** Full admins and curriculum developers can inspect every squad; other users must be assigned to it. */
export function canAccessSquad(user: SquadAccessUser, squad: AccessibleSquad): boolean {
  if (!user || !squad) return false;
  if (hasAdminPermission(user as User, 'curriculum.manage')) return true;
  return Array.isArray(squad.teacherIds) && squad.teacherIds.includes(String(user.id));
}
